import script from "./alarm-beep-config.vue?vue&type=script&lang=ts&setup=true"
export * from "./alarm-beep-config.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__